module.exports = __webpack_public_path__ + "img/no-winner.c219e53a.png";